module.exports = __webpack_public_path__ + "public/assets/img/forgot-password-v2-dark.38cc40f5.svg";